import IconArrowBack from '@/components/icons/arrowBack.vue'
import IconPencil from '@/components/icons/pencil.vue'
import IconBase from '@/components/IconBase.vue'
import IconForward from '@/components/icons/arrowForward.vue'
import IconCheck from '@/components/icons/check.vue'
import AddressForm from '@/components/AddressForm.vue'
import Globals from '@/assets/scripts/global-functions.js'
import BackButton from '@/components/BackButton.vue'
import NextButton from '@/components/forms/ButtonNext.vue'

export default {
    name: "MailingAddress",
    components: {
        IconBase,
        IconArrowBack,
        IconForward,
        IconCheck,
        AddressForm,
        BackButton,
        NextButton,
        Globals
    },
    data: () => ({
        /*issavepaper: false,*/
        mailing_address_id: -1,
        dialog: false
    }),
    computed: {
        AllFieldsValid: function() {
            let _isvalid = false;
            if(this.mailing_address_id > -1) {
                _isvalid = true;
            }
            return _isvalid;
        }
    },
    methods: {
        CloseModal() {
            this.dialog = false;
        },
        ValidateSessionData() { 
            /*var _mailing_address_id = this.$parent.EducatorInsuranceProcess.mailing_address_id;
            if(_mailing_address_id != undefined) {
                this.mailing_address_id = _mailing_address_id;
                document.getElementById("address" + this.mailing_address_id).classList.add("selected");
            } */
            const _length = this.$parent.EducatorInsuranceProcess.Addresses.length;
            for(var i = 0; i < _length; i++) {
                if(this.$parent.EducatorInsuranceProcess.Addresses[i].isselected == true) {
                    this.mailing_address_id = i;
                }
            }
        },
        SelectThisAddress(_eid) {
            if(!event.target.classList.contains("remove")) {
                /* , _unitnumber, _streetaddress, _suburb, _state, _postcode */
                var a = document.getElementById("address" + _eid);
                if(a.className.indexOf("selected") < 0) {
                    this.$parent.RemoveClassFrom("address-item", "selected");
                    a.classList.add("selected");
                    this.UnselectAllAddress();
                    this.$parent.EducatorInsuranceProcess.Addresses[_eid].isselected = true;
                    this.mailing_address_id = _eid;
                }
            }
        },
        UnselectAllAddress() {
            const _length = this.$parent.EducatorInsuranceProcess.Addresses.length;
            for(var i = 0; i < _length; i++) {
                this.$parent.EducatorInsuranceProcess.Addresses[i].isselected = false;
            }
        },
        DeleteThisAddress(_index) {
            if(event.target.classList.contains("remove")) {
               // this.$parent.EducatorInsuranceProcess.Addresses[_index].remove();
               if(this.$parent.EducatorInsuranceProcess.Addresses[_index].isselected) {
                   this.mailing_address_id = -1;
               }
               this.$parent.EducatorInsuranceProcess.Addresses.splice(_index, 1);
               this.$parent.SessionUpdate("EducatorInsuranceProcess");
            };
        },
        Next() {
            if(this.mailing_address_id > -1) {
                this.$parent.EducatorInsuranceProcess.mailing_address_id = this.mailing_address_id;
                /*this.$parent.EducatorInsuranceProcess.issavepaper = this.issavepaper;*/
                this.$parent.EducatorNextStep(10,"CoveredIndividuals"); 
            } 
        }
    },
    mounted() {
        this.$parent.EducatorInsuranceProcess = JSON.parse(localStorage.getItem("EducatorInsuranceProcess"));
        this.ValidateSessionData();
        this.$parent.CurrentProcess = "EducatorInsuranceProcess";
    }
}